import { PieChart as PieChartIcon, Users } from "lucide-react";
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { CHART } from "../../../lib/constants";
import { UnknownCallout } from "../components/UnknownCallout";
import {
  CHART_HEIGHT, PIE_INNER, PIE_OUTER, TOOLTIP_STYLE,
} from "../lib/chartTokens";

const PieBlock = ({ data }) => (
  <div className={CHART_HEIGHT}>
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={PIE_INNER}
          outerRadius={PIE_OUTER}
          paddingAngle={2}
          dataKey="value"
        >
          {data.map((entry) => (
            <Cell key={`cell-${entry.name}`} fill={entry.fill} />
          ))}
        </Pie>
        <Tooltip {...TOOLTIP_STYLE} />
        <Legend wrapperStyle={CHART.legend} />
      </PieChart>
    </ResponsiveContainer>
  </div>
);

export const OrientationCharts = ({
  orientationData,
  founderData,
  orientationUnknown,
  founderUnknown,
  totalApps,
}) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <div className="bg-card border border-border rounded-xl p-5">
      <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
        <PieChartIcon className="w-4 h-4 text-primary" />
        Value Orientation Distribution
      </h3>
      <PieBlock data={orientationData} />
      <p
        data-testid="orientation-unknown-note"
        className="text-xs text-muted-foreground mt-2 px-1 leading-relaxed"
      >
        All other apps are LLM-classified by product description and tagline.
      </p>
      {orientationUnknown > 0 && (
        <UnknownCallout
          count={orientationUnknown}
          total={totalApps}
          label="orientation"
          note="Apps not yet classified after multi-pass LLM enrichment."
        />
      )}
    </div>

    <div className="bg-card border border-border rounded-xl p-5">
      <h3 className="text-base font-semibold mb-4 flex items-center gap-2">
        <Users className="w-4 h-4 text-primary" />
        Founder Composition
      </h3>
      <PieBlock data={founderData} />
      {founderUnknown > 0 && (
        <UnknownCallout
          count={founderUnknown}
          total={totalApps}
          label="founder composition"
          note="Primarily HuggingFace community projects, anonymous open-source contributors, and apps with no publicly identifiable leadership."
        />
      )}
    </div>
  </div>
);

export default OrientationCharts;
